import { type FC } from 'react';
import BaseTransitionSlideLeft from '@/base/Transition/SlideLeft';
import { UiStack } from '@/lib/ui';
import InfoBox from '@/registration/component/InfoBox';
import GroupAttendees from './GroupAttendees';
import GroupAttendeeCategory from './GroupAttendeeCategory';
import QueryContainer from '@/base/QueryContainer/QueryContainer';
import { type GroupRegistration } from '@/api/registration/groupRegistration';
import { type UseQueryResult } from '@tanstack/react-query';

interface GroupRegistrationDetailProps {
  groupRegistrationQuery: UseQueryResult<GroupRegistration, Error>
}

const GroupRegistrationDetail: FC<GroupRegistrationDetailProps> = ({ groupRegistrationQuery }) => {
  return (
    <QueryContainer query={groupRegistrationQuery}>
      {(registration) => {
        // console.log(registration, '------');
        return (
          <UiStack flexGrow={1} spacing={8} enableDivider={false}>
            {/*<InfoBox*/}
            {/*  title={'My account'}*/}
            {/*/>*/}
            {!!registration.attendeeCategory && (
              <GroupAttendeeCategory attendeeCategory={registration.attendeeCategory} />
            )}
            <GroupAttendees groupRegistrationQuery={groupRegistrationQuery} />
          </UiStack>
        );
      }}
    </QueryContainer>
  );
};

export default GroupRegistrationDetail;
